export const APP = {
  LOTS_PER_PAGE: {
    DEFAULT: 9,
    VALUES: [9, 24, 48, 96]
  },
  LOT_ORDER: {
    LOT_NUMBER: 1,
    LOT_PRICE_ASC: 2,
    LOT_PRICE_DESC: 3,
  },
  RESULTS_LOT_ORDER: {
    LOT_NUMBER: 1,
    LOT_PRICE_ASC: 2,
    LOT_PRICE_DESC: 3,
    LOT_SOLD: 4,
    LOT_UNSOLD: 5
  }
}
